import React from 'react';

import * as classes from './IotHubTotals.module.css';

const IotHubTotals = ({
    label,
    value,
    ...props
}) => {

    return (
        <div className={classes.TotalsPanel}>
            <p className={classes.Title}>{label || ''}</p>
            <p className={classes.Value}>{value || '0'}</p>
        </div>
    );
};

export default IotHubTotals;
